import * as API_Common from '@/api/common.js'
import { formatAppFrameLinkUrl } from '@/utils/appFrameUrl.js'
export default {
  mounted() {
    this.trackTl5ThemeOneBase('100036')
  },
  methods: {
    trackTl5ThemeOneBase(eventType) {
      API_Common.handleBatchTrackBase(eventType)
    },

    /** 半流程：地址栏有 processId 时优先 getHalfDownloadUrl，无 url 再走 fallback */
    runHalfDownloadOrElse(fallback) {
      const processId = this.$route.query.processId
      if (!processId) {
        fallback()
        return
      }
      const channelCode = this.source || this.$route.query.source || ''
      API_Common.getHalfDownloadUrl(channelCode, processId)
        .then((res) => {
          console.log('半流程获取跳转url', JSON.stringify(res))
          if (res.code === 200 && res.data && res.data.url) {
            // 埋点
            API_Common.handleBatchTrackBase(100058, { remark: res.data.url })
            window.location.href = res.data.url
            return
          }
          fallback()
        })
        .catch(() => fallback())
    },

    /**
     * 主 CTA：根据分支上报不同埋点
     * isRedirectProductsPage=1: 跳贷超（100037）
     * isRedirectProductsPage=0: 触发 APP 下载（100038）
     */
    onUserConfirmQuotaClick() {
      if (this.isRedirectProductsPage === 1) {
        this.trackTl5ThemeOneBase('100037')
      } else {
        this.trackTl5ThemeOneBase('100038')
      }
      this.handleIGotIt()
    },

    /** 倒计时结束且不走贷超列表时调用 */
    autoDownloadAfter3Seconds() {
      this.runHalfDownloadOrElse(() => this.autoDownloadApp())
    },

    // 监听产品点击
    handleProductClick(obj, showPage) {
      if (obj.checkMobileStatus != 0) {
        this.trackTl5ThemeOneBase('100040')
        setTimeout(() => {
          window.location.href = `/productDetail?productId=${obj.productId}&showPage=${showPage}&source=${this.source}`
        }, 600)
        // 联登产品跳详情
      } else {
        this.trackTl5ThemeOneBase('100039')
        // 埋点
        API_Common.buried({
          productId: obj.productId,
          showPage,
        })
          .then((res) => {
            const productId = res.data.productId || obj.productId
            const linkUrl = res.data.linkUrl
            window.location.href =
              '/appFrame?productId=' + productId + '&url=' + formatAppFrameLinkUrl(linkUrl)
            sessionStorage.setItem('lastUrl', window.location.href)
          })
          .catch((error) => {
            console.error('产品实时校验失败', error)
          })
      }
    },
    isWeixin() {
      var ua = navigator.userAgent.toLowerCase()
      return ua.indexOf('micromessenger') !== -1
    },
    // 下载按钮点击
    handleDownload() {
      let isWeixin = this.isWeixin()
      if (isWeixin) {
        this.showPop = true
      } else if (this.brand === 'xiaomi') {
        window.location.href = 'https://app.xiaomi.com/detail/1500555'
      } else {
        this.runHalfDownloadOrElse(() => {
          console.log('下载app', this.source)
          setTimeout(() => {
            window.location.href = this.downAppUrl
          }, 50)
        })
      }
    },
  },
  beforeDestroy() {
    window.__TRACK_SCENE_KEY__ = ''
  },
}
